var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dayNews
    ? _c("div", [
        _c("div", { staticClass: "mt-3 d-flex flex-column flex-grow-1" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "sect-atentos flex-grow-1" }, [
            _c(
              "div",
              { staticClass: "time-line" },
              _vm._l(_vm.dayNews.feed, function (item) {
                return _c("day-news-feed-item", {
                  key: item.id,
                  attrs: { item: item },
                })
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "atento-title" }, [
      _c("div", { staticClass: "title" }, [_vm._v("ATENTO")]),
      _vm._v(" "),
      _c("div", { staticClass: "real-time" }, [_vm._v("TIEMPO REAL")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row flex-shrink-1" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "button" }, [
          _c("a", { staticClass: "btn", attrs: { href: "/atento" } }, [
            _vm._v("MÁS INFORMACIÓN"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }